import uniqBy from 'lodash/uniqBy';

import { formatSocialProfileType } from '@/lib/socialProfile';

import {
    ActionsCell,
    ActionsDownloadCell,
    ContentCell,
    CreatedAtCell,
    FormatCell,
    FrequencyCell,
    NextDeliveryCell,
    PeriodCell,
    RecipientCell,
    TitleCell,
    TypeCell
} from '@/components/pages/reports/components/Cells';

class TableColumnsService {
    getScheduledReportColumns = (t, toggle, setModalParams) => [
        {
            Header: t('general.type_title'),
            id: 'type',
            accessor: 'type',
            Cell: TypeCell
        },
        {
            Header: t('general.title_title'),
            id: 'name',
            accessor: 'name',
            sortable: 'name',
            Cell: TitleCell
        },
        {
            Header: t('general.content_title'),
            id: 'content',
            accessor: (row) => {
                const sp = [];
                row?.social_profiles?.map((profile) => {
                    sp.push({
                        value: profile?.slug,
                        label: `${profile?.slug} (${formatSocialProfileType(profile)})`,
                        id: profile?.id
                    });
                });
                const outputFiltered = uniqBy(sp, 'id');
                return outputFiltered?.map((el) => el?.label)?.join(' ') ?? '';
            },
            Cell: (row) => ContentCell({ value: row?.cell?.row?.original }),
            disableSortBy: true
        },
        {
            Header: t('general.format_title'),
            id: 'format',
            accessor: 'format',
            sortable: 'type',
            Cell: FormatCell
        },
        {
            Header: t('general.frequency'),
            id: 'frequency',
            accessor: 'frequency',
            sortable: 'frequency',
            Cell: FrequencyCell
        },
        {
            Header: t('general.delivery'),
            id: 'next_execution',
            accessor: 'next_execution',
            sortable: 'next_execution',
            Cell: NextDeliveryCell
        },
        {
            Header: t('general.recipients'),
            id: 'recipients',
            accessor: 'params.emails',
            Cell: RecipientCell
        },
        {
            id: 'edit',
            accessor: '',
            Cell: (row) => ActionsCell({ toggle, setModalParams, row })
        }
    ];

    getHistoryReportColumns = (t) => [
        {
            Header: t('general.type_title'),
            id: 'type',
            accessor: 'type',
            Cell: TypeCell
        },
        {
            Header: t('general.title_title'),
            id: 'name',
            accessor: 'name',
            sortable: 'name',
            Cell: TitleCell
        },
        {
            Header: t('general.content_title'),
            id: 'content',
            accessor: (data) => {
                const sp = [];
                data?.social_profiles?.map((profile) => {
                    sp?.push({
                        value: profile?.slug,
                        label: `${profile?.slug} (${formatSocialProfileType(profile)})`,
                        id: profile?.id
                    });
                });
                const outputFiltered = uniqBy(sp, 'id');
                return outputFiltered?.map((el) => el?.label)?.join(' ') ?? '';
            },
            Cell: (row) => ContentCell({ value: row?.cell?.row?.original })
        },
        {
            Header: t('general.format_title'),
            id: 'format',
            accessor: 'format',
            sortable: 'params->type',
            Cell: FormatCell
        },
        {
            Header: t('general.period_title'),
            id: 'period',
            accessor: 'start_date',
            sortable: 'params->period',
            Cell: PeriodCell
        },
        {
            Header: t('general.creation_title'),
            id: 'created_at',
            accessor: 'created_at',
            sortable: 'created_at',
            Cell: CreatedAtCell
        },
        {
            Header: t('general.recipients'),
            id: 'recipients',
            accessor: 'params.emails',
            Cell: RecipientCell
        },
        {
            id: 'download',
            accessor: '',
            Cell: ActionsDownloadCell
        },
        {
            id: 'frequency',
            accessor: 'frequency'
        }
    ];
}

const tableColumnsService = new TableColumnsService();

export { tableColumnsService as TableColumnsService };
